module.exports = __webpack_public_path__ + "static/media/michael.ceae3755.png";